import { HostFamilyLecCommentGuest } from '../../../lib/types/models/host-family-lec-comment/host-family-lec-comment'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function getHostFamilyLecCommentGuests(hostFamilyId: number) {
  return restApiClient
    .url(constructApiUrl(API.hostFamilies.getHostFamilyLecCommentGuests.url, { hostFamilyId }))
    .get<HostFamilyLecCommentGuest[]>()
}
